import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Header from "../../../layout/mypage/Header";
import Footer from "../../../layout/mypage/Footer";
import ScreenColorSetting, {
  getDefaultScreenColor,
} from "../../../layout/mypage/ScreenColorSetting";
import {
  validateMinlength,
  validateConfirm,
  validateHalfAlphaNum,
} from "../../../../utils/validate";
import {
  postPasswordSetting,
  getIsExpire,
} from "../../../../services/apiMyPageLogin";
import { useLocation } from "react-router-dom";
import TextField from "../../../ui/TextField";
import MypageTextField from "../../../ui/MypageTextField";
import { MYPAGE_HTML_TITLE } from "../../../../utils/config";

// パスワード再設定画面
const PasswordSetting = () => {
  // トークン取得の為のURL情報
  const [urlInfo, setUrlInfo] = useState(useLocation().pathname);
  // 期限切れか？
  const [expireFlg, setExpireFlg] = useState(false);
  // パスワード再設定完了フラグ
  const [compFlg, setCompFlg] = useState(false);
  // エラーメッセージ
  const [errorMsg, setErrorMsg] = useState("");
  // 画面背景色 color-standard or color-black or color-blue
  const [screenColor, setScreenColor] = useState(getDefaultScreenColor());

  // 入力チェック用
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    watch,
    formState: { errors },
  } = useForm();

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  // 初期レンダリング
  useEffect(() => {
    // トークンデータセット
    (async function () {
      scrollTop();
      document.title = `パスワード再設定 | ${MYPAGE_HTML_TITLE}`;
      // 期限切れか？
      const token = urlInfo
        .replace("/mypage/passwordsetting/", "")
        .slice(0, -1);
      const result = await getIsExpire({ token: token });
      if (!result || !result.result) {
        setExpireFlg(true);
        return;
      }
      setValue("token", token);
    })();
  }, []);

  // 変更を確定するボタン
  const onSubmit = async (data) => {
    const result = await postPasswordSetting(data);
    if (!result) return;
    if (result.is_valid) {
      setCompFlg(true);
    } else {
      // エラーメッセージ
      setError(result.name, { message: result.msg });
    }
    scrollTop();
  };

  return (
    <>
      <ScreenColorSetting
        screenColor={screenColor}
        setScreenColor={setScreenColor}
      />
      <div className="mypage-site">
        <Header
          setScreenColor={setScreenColor}
          screenColor={screenColor}
          isLogin={false}
        />
        {expireFlg ? (
          <main className="l-main">
            <div className="container">
              <div className="col-lg-10 offset-lg-1">
                <div className="p-login-con">
                  <h1 className="p-heading01">無効なURLです</h1>
                  <div className="p-login-txtbox">
                    <p>
                      URLの有効期限が切れているか無効なため、パスワード再設定ページにアクセスできませんでした。
                    </p>
                    <p>
                      お手数ですが、もう一度再設定メールを送信するか、最新のメールから有効なURLにアクセスしてください。
                    </p>
                  </div>
                  <div className="p-login-form__btnbox">
                    <Link className="p-login-form__link" to="/mypage/password">
                      パスワード再設定メール送信ページへ進む
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </main>
        ) : compFlg ? (
          <main className="l-main">
            <div className="container">
              <div className="col-lg-10 offset-lg-1">
                <div className="p-login-con">
                  <h1 className="p-heading01">パスワードの再設定完了</h1>
                  <div className="p-login-txtbox">
                    <p>パスワードの再設定を完了致しました。</p>
                  </div>
                  <div className="p-login-form__btnbox">
                    <Link className="p-login-form__link" to="/mypage/login">
                      ログイン画面へ戻る
                    </Link>
                  </div>
                </div>
                <div className="p-login-return">
                  <a
                    className="p-login-return__link"
                    href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
                  >
                    <img
                      className="p-login-return__img"
                      src="/common/assets/images/logo02.svg"
                      alt=""
                    />
                    <span className="p-login-return__txt">
                      シブカツトップページに戻る
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </main>
        ) : (
          <main className="l-main">
            <div className="container">
              <div className="col-lg-10 offset-lg-1">
                <div className="p-login-con">
                  <h1 className="p-heading01">パスワード再設定</h1>
                  <p className="mt-5 mb-5">
                    パスワードは8～12文字の半角英数文字で設定可能です。
                  </p>
                  <form
                    action=""
                    className="p-login-form"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="p-login-con__form">
                      <MypageTextField
                        type="password"
                        name="password"
                        label="新しいパスワード"
                        maxLength={12}
                        register={register}
                        validation={{
                          ...validateMinlength(8),
                          ...validateHalfAlphaNum(),
                        }}
                        errors={errors}
                        watch={watch}
                        required={true}
                        placeholder="パスワード"
                        autocomplete="new-password"
                      />
                      <MypageTextField
                        type="password"
                        name="password2"
                        label="新しいパスワード(確認用)"
                        maxLength={12}
                        register={register}
                        validation={{
                          ...validateMinlength(8),
                          ...validateHalfAlphaNum(),
                          ...validateConfirm(
                            "password",
                            "password2",
                            "パスワード"
                          ),
                        }}
                        errors={errors}
                        watch={watch}
                        required={true}
                        placeholder="パスワード(確認用)"
                        autocomplete="new-password"
                      />
                      <div hidden>
                        <TextField
                          errors={errors}
                          register={register}
                          validation={{}}
                          label=""
                          name="token"
                          isStatic={true}
                        />
                      </div>
                      <div className="p-login-form__btnbox">
                        <div className="p-login-form__send">
                          <input
                            className="p-login-form__link"
                            type="submit"
                            value="変更を確定する"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="p-login-return">
                  <a
                    className="p-login-return__link"
                    href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
                  >
                    <img
                      className="p-login-return__img"
                      src="/common/assets/images/logo02.svg"
                      alt=""
                    />
                    <span className="p-login-return__txt">
                      シブカツトップページに戻る
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </main>
        )}
        <Footer is_login={true} />
      </div>
    </>
  );
};
export default PasswordSetting;
